// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__EdLVU","label":"Radio_label__3VMcm","checkMark":"Radio_checkMark__2gjdh","disabled":"Radio_disabled__VkDm-"};